import React from "react";
import { useAuthContext } from "../../../lib/context/AuthContext/AuthContext";
import { useQuery } from "@apollo/react-hooks";
import { shouldShowPriceForCategories } from "../../../lib/helpers/getCategoryDescendants";
import * as shopQueries from "../../../queries/shop";

interface Props {
  productCategories?: {
    nodes: {
      id: string;
      slug: string;
      name: string;
      databaseId: number;
    }[];
  };
}

export const PriceCategoryDebug = (props: Props) => {
  const authCtx = useAuthContext();
  const { data: categoryData } = useQuery<
    shopQueries.GetAllProductCategoriesResponse
  >(shopQueries.getAllProductCategories);

  const productCategoryIds = props.productCategories?.nodes?.map(cat => cat.databaseId) || [];
  const showPriceCategories = authCtx.user?.showPriceCategories || [];

  const shouldShowPrice = shouldShowPriceForCategories(
    productCategoryIds,
    showPriceCategories,
    categoryData?.productCategories?.nodes || []
  );

  return (
    <div style={{ 
      fontSize: '11px', 
      color: '#999', 
      margin: '5px 0', 
      border: '1px solid #ddd',
      padding: '5px',
      backgroundColor: '#f9f9f9'
    }}>
      <div><strong>Price Category Debug:</strong></div>
      <div>Auth: {authCtx.isAuthenticated ? 'Yes' : 'No'}</div>
      <div>User: {authCtx.user ? 'Yes' : 'No'}</div>
      <div>Show Price Categories: {showPriceCategories.length > 0 ? 
        showPriceCategories.map(cat => `${cat.name}(${cat.databaseId})`).join(', ') : 'Empty'}</div>
      <div>Product Categories: {productCategoryIds.length > 0 ? 
        productCategoryIds.join(', ') : 'None'}</div>
      <div>Product Category Names: {props.productCategories?.nodes?.map(cat => cat.name).join(', ') || 'None'}</div>
      <div>All Categories Loaded: {categoryData?.productCategories?.nodes ? 'Yes' : 'No'} ({categoryData?.productCategories?.nodes?.length || 0} categories)</div>
      <div><strong>Should Show Price: {shouldShowPrice ? 'YES' : 'NO'}</strong></div>
    </div>
  );
}; 